module.exports = __webpack_public_path__ + "img/laurie.aa4978cc.jpg";